import { render, staticRenderFns } from "./CompanyFilters.vue?vue&type=template&id=067ff78a"
import script from "./CompanyFilters.vue?vue&type=script&lang=js"
export * from "./CompanyFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports